import { defineStore } from 'pinia'
import { Lang } from 'quasar'
import type { QuasarLanguage } from 'quasar'
import langEn from 'quasar/lang/en-US'
import langFr from 'quasar/lang/fr'
import { i18n } from 'src/CrudManager/Core/Utils/i18n'
import { computed, ref } from 'vue'
import type { LabelValue } from '../../../interfaces/Shared'

// useUser  handles the user's data and actions

export interface I18nInterface {
  language: LabelValue
  currency: string
}

type LangShort = 'fr' | 'en'
type currencyCode = 'USD' | 'CAD'

// Endonyms: a language picker has to be readable to someone who cannot read
// the locale currently active, so these are deliberately never translated.
const defaultLanguageOptions = [
  { label: 'Français', value: 'fr' },
  { label: 'English', value: 'en' },
]

// Quasar ships its own label set (Cancel/OK, QDate month names). It has to be
// switched alongside vue-i18n or Quasar-owned widgets stay in the old language.
const quasarLanguagePacks: Record<LangShort, QuasarLanguage> = {
  fr: langFr,
  en: langEn,
}

const defaultCurrencyOptions = [
  { label: 'CAD', value: 'CAD' },
  { label: 'USD', value: 'USD' },
]

export const useI18nStore = defineStore(
  'I18n',
  () => {
    const language = ref({ ...defaultLanguageOptions[0] } as LabelValue)
    const currency = ref({ ...defaultCurrencyOptions[0] } as LabelValue)

    const Options = ref({
      languages: defaultLanguageOptions.map((option) => ({ ...option })) as LabelValue[],
      currencies: defaultCurrencyOptions.map((option) => ({ ...option })) as LabelValue[],
    })

    const getI18N = () => {
      /*
       *axiosApi.get('/i18n/getOptions').then(response => {
       *  Options.value.currencies = response.data.currencies;
       *  Options.value.languages = response.data.languages;
       *});
       */
    }

    /**
     * Applies a language across both translation layers. Called with no
     * argument on boot to re-apply the persisted language, since `language` is
     * restored from storage but the i18n instance always starts on its default.
     */
    const switchLocale = (lang?: LabelValue) => {
      language.value = { ...(lang || language.value) }

      i18n.locale.value = languageCode.value
      Lang.set(quasarLanguagePacks[languageCode.value])
    }

    const swithCurrency = (newCurrency?: LabelValue) => {
      currency.value = { ...(newCurrency || currency.value) }
      // todo: set currency
    }

    const languageCode = computed(() => {
      return language.value.value as LangShort
    })

    const currencyCode = computed(() => {
      return currency.value.value as currencyCode
    })
    const getModelString = (modelName: string, key: string, props: object | null = null) => {
      return props ? i18n.t(`crudmodels.${modelName}.${key}`, props) : i18n.t(`crudmodels.${modelName}.${key}`)
    }

    const getI18nMessage = (message: string) => {
      return i18n.t(message)
    }

    return { getModelString, language, currency, Options, getI18N, languageCode, currencyCode, switchLocale, swithCurrency, getI18nMessage }
  },
  // Only the user's choices belong in storage. `Options` is build-time config,
  // and persisting it froze the option list of whatever version first ran.
  { persist: { pick: ['language', 'currency'] } },
)
